export const PATH = {
  HOME: '/',
  NOT_FOUND: '/404',
  NO_CONNECTION: '/no-connection',
  ACCOUNT_VERIFY: '/account-verify',
  ADMIN_DASHBOAR: '/dashboard',
  QR_AFFILIATE: '/qr-affiliate',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  UPDATE_PROFILE: '/profile',

  UPOS_STORE_MANAGEMENT: '/upos/shop',
  UPOS_STORE_DETAIL: '/upos/shop/:shopId',
  UPOS_CREATE_STORE: '/upos/shop/create',
  EVOSHOP_STORE_MANAGEMENT: '/evoshop/shop',
  EVOSHOP_STORE_DETAIL: '/evoshop/shop/:shopId',
  EVOSHOP_CREATE_STORE: '/evoshop/shop/create',

  USER_MANAGEMENT: '/users',
  CREATE_USER: '/users/create',
  UPDATE_USER: '/users/edit/:userId',
  USER_ROLE: '/user/groups',
  USER_ROLE_CREATE: '/user/groups/create',
  USER_ROLE_EDIT: '/user/groups/edit/:id',

  NOT_PERMISSION: '/not-permission',

  CATEGORY: '/category',

  PRODUCT: '/product',
  CREATE_PRODUCT: '/product/create',
  DETAIL_PRODUCT: '/product/edit/:productId',
  DIGITAL_PRODUCT: '/digital-product',
  CREATE_DIGITAL_PRODUCT: '/digital-product/create',
  DETAIL_DIGITAL_PRODUCT: '/digital-product/edit/:productId',

  ORDER_BOOK: '/order/books',
  ORDER_DIGITAL: '/order/digital',
  CREATE_ORDER: '/order/create',
  EDIT_ORDER_BOOK: '/order/:orderId',
  HISTORY_ORDER_BOOK: '/order/history/:historyId',
  CREATE_DIGITAL_ORDER: '/digital-order/create',
  DETAIL_DIGITAL_ORDER: '/digital-order/:orderId',

  PRINCIPAL: '/principal',
  CREATE_PRINCIPAL: '/principal/create',
  DETAIL_PRINCIPAL: '/principal/:principalId',
  TEACHER: '/teacher',
  CREATE_TEACHER: '/teacher/create',
  DETAIL_TEACHER: '/teacher/:teacherId',
  STUDENT: '/students',
  CUSTOMER: '/customer',
  PRODUCT_OF_CUSTOMER: '/customer/:customerId/config-product',
  CREATE_STUDENT: '/student/create',
  DETAIL_STUDENT: '/student/:studentId',

  COMMISSION: '/commission',
  DETAIL_COMMISSION: '/commission/:commissionId',
  REVENUE: '/revenue',
  DETAIL_REVENUE: '/revenue/:revenueId',

  PAYMENT_VOUCHER: '/accountant/receipt',
  COMMISSION_VOUCHER: '/accountant/invoice-commission',
  CREATE_COMMISSION_VOUCHER: '/accountant/invoice-commission/create',
  BANNER: '/banners',
  KEY_PRODUCT: '/key-dproduct',
  CONFIG_PAYMENT: '/payment/config',
  CONFIG_NOTIFICATION: '/notification/config',
}
